import { render, staticRenderFns } from "./DirectionSelector.vue?vue&type=template&id=0d274662&scoped=true&"
import script from "./DirectionSelector.vue?vue&type=script&lang=js&"
export * from "./DirectionSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d274662",
  null
  
)

export default component.exports